import { PayloadAction } from "@reduxjs/toolkit";
import { commonFilters } from "../common-filters/common-filters";

export function resetFiltersReducer(state, action: PayloadAction<void>) {
  state.filters = state.filters.map((f) => {
    if (f.id !== "common" && f.id !== "history-diagnostics" && f.id !== "history-up") {
      return {
        ...f,
        filters: f.filters.map((ff) => {
          if(ff.singleOption)
            return {...ff, enabled: false}
          return {...ff, enabled: true, enabledValues: []}
        }),
      };
    }

    if(f.id === "history-diagnostics" || f.id === "history-up") {
      return {
        ...f,
        enabledValues: [],
      };
    }
    if(f.id === "common") {
      return commonFilters[0]
    }
    return f;
  });
}
